import { render } from "./BlogInstanceTable.vue?vue&type=template&id=0a961e2e"
import script from "./BlogInstanceTable.vue?vue&type=script&lang=js"
export * from "./BlogInstanceTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__